import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
export interface ProjectMasterState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allProjectMaster: [] | null | any;
}
const initialState: ProjectMasterState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allProjectMaster: null
};
export const projectMasterSlice = createSlice({
  name: 'projectMaster',
  initialState,
  reducers: {
    setAllProjectMaster: (state, action) => {
      state.allProjectMaster = action.payload.data;
    },
    setProjectMaster: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllProjectMasterBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});
// Action creators are generated for each case reducer function
export const { setAllProjectMaster, setProjectMaster, setAllProjectMasterBySearch,reset } = projectMasterSlice.actions;
export const allProjectMasterDetails = (state: RootState) => state.projectMaster.allProjectMaster;
export const getAllProjectMasterDetails = (state: RootState) => state.projectMaster.data;
export const getProjectMasterTotalRecords=(state:RootState)=>state.projectMaster.totalRecords;
export const getAllProjectMasterBySearch = (state: RootState) => state.projectMaster.data;
export default projectMasterSlice.reducer;